import * as React from 'react';
import { Panel, PanelType, DefaultButton, PrimaryButton, Label, Toggle } from 'office-ui-fabric-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ProjectsListStore from '../../store/ProjectsListStore';
import FieldLabel from '../integration/FieldLabel';
import PPMXSharePeoplePicker, { IUserProps } from '../common/inputs/PPMXSharePeoplePicker';
import LabellableComponent from '../common/LabellableComponent';
import { UserStatus } from '../../store/User';

type OwnProps = {
    projectIds: string[];
    onDismiss: () => void;
}

type StateProps = {}

type ActionProps = {
    projectActions: typeof ProjectsListStore.actionCreators;
}

type Props = OwnProps & StateProps & ActionProps;

const ProjectShareReport = (props: Props) => {
    const [selectedUsers, setSelectedUsers] = React.useState<IUserProps[]>([]);
    const [mergePdfs, setMergePdfs] = React.useState<boolean>(true);

    const _onRenderHeader = React.useCallback(() => {
        return <div className="ms-Panel-header">
            <p className="ms-Panel-headerText">Share Report</p>
            <div className='ms-Panel-secondaryText'>
                Select PPM Express users or enter email addresses to share the Project Story report.
            </div>
        </div>;
    }, []);

    const isValidForm = (): boolean => !!props.projectIds.length && !!selectedUsers.length;

    const _send = React.useCallback(() => {
        if (!isValidForm()) {
            return;
        }
        const recepients = selectedUsers.map(_ => _.email);
        props.projectActions.sendMultiProjectReport(props.projectIds, recepients, mergePdfs);

        props.onDismiss();
    }, [props.onDismiss, props.projectIds, selectedUsers, mergePdfs]);

    const _onRenderFooterContent = React.useCallback(() => (
        <div className="commands">
            <PrimaryButton
                text="Send"
                disabled={!isValidForm()}
                onClick={_send}
            />
            <DefaultButton text="Cancel" onClick={props.onDismiss} />
        </div>
    ), [props.onDismiss, selectedUsers, mergePdfs]);

    return <Panel
        className="project-share-report"
        isLightDismiss={true}
        type={PanelType.custom}
        customWidth="400px"
        isOpen={true}
        onRenderHeader={_onRenderHeader}
        onRenderFooterContent={_onRenderFooterContent}
        onDismiss={props.onDismiss}>
        <div className='share-field'>
            <Label>
                <FieldLabel
                    label='Recipients'
                    title='Select an existing PPM Express user or enter an email address to share the Project Story report.
                        Please note that sending the report will not send a tenant invitation.'/>
            </Label>
            <PPMXSharePeoplePicker
                pickerPlaceholder='Name or email address'
                selectedUsers={selectedUsers}
                setSelectedUsers={setSelectedUsers}
                maxUsersCount={10}
                userStatus={UserStatus.Active} />
        </div>
        <div className='share-field'>
            <LabellableComponent
                label="Single PDF file"
                description={(<span>Send one PDF file with reports for all selected projects. When disabled, a separate PDF file is created for each project.</span>)}>
                <div className="field-value">
                    <Toggle
                        checked={mergePdfs}
                        onChange={() => setMergePdfs(!mergePdfs)} />
                </div>
            </LabellableComponent>
        </div>
    </Panel>;
}

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        projectActions: bindActionCreators(ProjectsListStore.actionCreators, dispatch),
    };
}

export default connect(undefined, mergeActionCreators)(ProjectShareReport);